const StickyNavigation = (($) => {

    const ELEMENT_NAME = '[data-sticky-navigation]';

    class StickyNavigation {
        constructor(element) {}
    }


    $(document).on("scrolldirectionchange", function (evt, direction) {

        if (direction === "down") {
            $('body').addClass('scroll-down');
        } else {
            $('body').removeClass('scroll-down');
        }

    });

    return StickyNavigation;

})(jQuery);

// export default StickyNavigation
